export default "__VITE_ASSET__eS$1DxZ$__"